import Konva from "konva";
import { DMCRectangle } from "../KObjects/DMCRectangle";

export class Rectangle {
  constructor() {
    this.currentMousePosDown = "";
    this.currentObject = null;
    this.currentShapeConfig = {};
    this.interval = false;
    this.origin = {};
    this.name = "Rect";
    (this.type = "widget"),
      (this.currentOptions = {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        scaleX: 0,
        scaleY: 0,
      });
  }

  createControllerObject(name, konvaObject) {
    return new DMCRectangle(name, konvaObject);
  }

  createNew(controllerProject, dataScrolling = null) {
    const currentMousePos = controllerProject.collectCurrentMousePosition();
    this.currentShapeConfig = {};
    this.currentShapeConfig.scaleX = 1;
    this.currentShapeConfig.scaleY = 1;
    this.currentShapeConfig.x = Math.round(currentMousePos.x / controllerProject.scale);
    this.currentShapeConfig.y = Math.round(currentMousePos.y / controllerProject.scale);
    this.currentShapeConfig.rotation = 0;
    this.currentShapeConfig.fill = controllerProject.mainColor;
    this.currentShapeConfig.strokeWidth = 5;
    this.currentShapeConfig.draggable = true;

    this.currentShapeConfig.dragBoundFunc = function (pos) {
      controllerProject.stage.container().style.cursor = "grabbing";
      let x = pos.x;
      let y = pos.y;
      if (dataScrolling != null) {
        if (dataScrolling.axe) {
          x = this.absolutePosition().x;
        } else {
          y = this.absolutePosition().y;
        }
      }

      if (!controllerProject.canObjectMove) {
        return {
          x: this.absolutePosition().x,
          y: this.absolutePosition().y,
        };
      } else {
        return {
          x: x,
          y: y,
        };
      }
    };

    this.currentObject = this.createNewForm();
    controllerProject.addElementToCurrentLayer(this.currentObject);
    this.currentShapeConfig = this.currentObject.attrs;
  }

  createNewForm() {
    return new Konva.Rect(this.currentShapeConfig);
  }

  createTransformer(elementToTransform) {
    return new Konva.Transformer({
      node: elementToTransform,
      keepRatio: false,
      enabledAnchors: [
        "top-left",
        "top-center",
        "top-right",
        "middle-right",
        "middle-left",
        "bottom-center",
        "bottom-left",
        "bottom-right",
      ],
    });
  }

  mouseDown(controllerProject) {
    this.currentMousePosDown = controllerProject.collectCurrentMousePosition();
    this.createNew(controllerProject);
    this.origin.x = controllerProject.collectCurrentMousePosition().x / controllerProject.scale;
    this.origin.y = controllerProject.collectCurrentMousePosition().y / controllerProject.scale;

    if (!this.interval) {
      this.interval = setInterval(() => {
        const currentMousePos = controllerProject.collectCurrentMousePosition();
        const distanceX = Math.round(Math.abs(this.origin.x - currentMousePos.x / controllerProject.scale));
        const distanceY = Math.round(Math.abs(this.origin.y - currentMousePos.y / controllerProject.scale));

        if (currentMousePos.x / controllerProject.scale < this.origin.x) {
          this.currentObject.setAttr("x", Math.round(currentMousePos.x / controllerProject.scale));
        }
        if (currentMousePos.y / controllerProject.scale < this.origin.y) {
          this.currentObject.setAttr("y", Math.round(currentMousePos.y / controllerProject.scale));
        }

        if (controllerProject.shiftKeyPressed) {
          let length = distanceX > distanceY ? distanceY : distanceX;
          length = Math.round(length);
          this.currentObject.setAttr("width", length);
          this.currentObject.setAttr("height", length);
        } else {
          this.currentObject.setAttr("width", distanceX);
          this.currentObject.setAttr("height", distanceY);
        }

        this.updateCurrentOptions(
          this.currentObject.getAttr("x"),
          this.currentObject.getAttr("y"),
          this.currentObject.getAttr("width"),
          this.currentObject.getAttr("height")
        );
      }, 30);
    }
  }

  mouseUp(controllerProject) {
    this.singleClickPrevent(controllerProject);

    clearInterval(this.interval);
    this.interval = false;
    controllerProject.destroyAllTransformer();
    controllerProject.currentSelection = this.createTransformer(this.currentObject);

    controllerProject.addElementToCurrentLayer(controllerProject.currentSelection);
    const name = controllerProject.addNewObjectToCurrentLayer(this.currentObject, this.name, this);

    try {
      controllerProject.stage.draw();
    } catch (err) {
      console.error(err);
    }

    this.currentOptions = this.resetOptions();
    return name;
  }

  resetOptions() {
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      scaleX: 0,
      scaleY: 0,
      rotation: 0,
    };
  }

  singleClickPrevent(controllerProject) {
    const currentMousePos = controllerProject.collectCurrentMousePosition();
    if (this.currentObject !== null) {
      if (
        Math.abs(this.currentMousePosDown.x - currentMousePos.x) < 5 &&
        Math.abs(this.currentMousePosDown.y - currentMousePos.y) < 5
      ) {
        this.currentObject.setAttr("width", controllerProject.projectSize.width);
        this.currentObject.setAttr("height", controllerProject.projectSize.height);
        this.currentObject.setAttr("X", 0);
        this.currentObject.setAttr("Y", 0);
        this.currentObject.setAttr("rotation", 0);
      }
    }
  }

  updateCurrentOptions(x, y, width, height) {
    this.currentOptions.x = x;
    this.currentOptions.y = y;
    this.currentOptions.width = width;
    this.currentOptions.height = height;
  }
}
